import { render, staticRenderFns } from "./ProductionHistory.vue?vue&type=template&id=aee3596e&"
import script from "./ProductionHistory.vue?vue&type=script&lang=js&"
export * from "./ProductionHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports